// This file is autogenerated. Any changes will be overwritten in next build.

import { Account } from "./Account";
import { ArrowDown } from "./ArrowDown";
import { ArrowUp } from "./ArrowUp";
import { Boleto } from "./Boleto";
import { Check } from "./Check";
import { ChevronDown } from "./ChevronDown";
import { ChevronLeft } from "./ChevronLeft";
import { ChevronRight } from "./ChevronRight";
import { ChevronUp } from "./ChevronUp";
import { Close } from "./Close";
import { CreditCard } from "./CreditCard";
import { EyeClosed } from "./EyeClosed";
import { EyeOpen } from "./EyeOpen";
import { Funnel } from "./Funnel";
import { Handshake } from "./Handshake";
import { Info } from "./Info";
import { Pilot } from "./Pilot";
import { PseudoIcon } from "./PseudoIcon";
import { RoundHangar } from "./RoundHangar";
import { Search } from "./Search";
import { Sort } from "./Sort";
import { Trash } from "./Trash";
import { Warning } from "./Warning";
const Assets = {
  Account,
  ArrowDown,
  ArrowUp,
  Boleto,
  Check,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  Close,
  CreditCard,
  EyeClosed,
  EyeOpen,
  Funnel,
  Handshake,
  Info,
  Pilot,
  PseudoIcon,
  RoundHangar,
  Search,
  Sort,
  Trash,
  Warning
};
export { Assets };
export { Account };
export { ArrowDown };
export { ArrowUp };
export { Boleto };
export { Check };
export { ChevronDown };
export { ChevronLeft };
export { ChevronRight };
export { ChevronUp };
export { Close };
export { CreditCard };
export { EyeClosed };
export { EyeOpen };
export { Funnel };
export { Handshake };
export { Info };
export { Pilot };
export { PseudoIcon };
export { RoundHangar };
export { Search };
export { Sort };
export { Trash };
export { Warning };